export default {
  setRegions: function setRegions(state, payload) {
    state.regions = payload;
  },
  setSections: function setSections(state, payload) {
    state.sections = payload;
  },
  // setUsers(state, payload) {
  //   state.users = payload
  // },
  setTags: function setTags(state, payload) {
    state.tags = payload;
  },
  setTagsOrg: function setTagsOrg(state, payload) {
    state.tags_org = payload;
  },
  setUpdateHours: function setUpdateHours(state, payload) {
    state.updateHours = payload;
  }
};